<template>
  <section
    class="navigation-section"
    :style="{
      '--back-color': bgColor
        ? `var(--framework-${bgColor})`
        : 'var(--background-base)',
    }"
  >
    <h2 class="navigation-section__title">
      {{ title }}
    </h2>
    <div class="navigation-section__top">
      <CardRive
        v-for="page of pages"
        class="navigation-section__top__card"
        :key="page"
        :url="page"
        :title="$t(`navigation.${page}`)"
        :routeObj="{ name: 'page', params: { page } }"
        @mouseenter="bgColor = page"
        @mouseleave="bgColor = ''"
      />
    </div>
  </section>
</template>

<script setup>
import CardRive from "../atoms/CardRive.vue";
import { ref } from "vue";

import { computed } from "vue";
import { useI18n } from "vue-i18n";

defineProps({
  title: String,
  introText: String,
  cta: String,
});

const i18n = useI18n();
const { tm } = useI18n();
const bgColor = ref();

const pages = computed(() =>
  Object.keys(tm("navigation")).filter((page) => !["home"].includes(page))
);
</script>

<style lang="scss" scoped>
.navigation-section {
  background-color: var(--back-color);
  color: var(--color-white);
  padding: 6vh var(--page-padding-h) 6vh
    calc(var(--page-padding-h) + var(--page-padding-h-offset));
  transition: background-color 0.3s ease;
  &__title {
    @include header-h-1;

    margin-bottom: toRem(6);
  }

  &__top {
    display: flex;
    gap: 1rem;
    margin-top: 6vh;

    .mobile &,
    .tablet & {
      flex-wrap: wrap;
      max-width: 400px;
    }

    &__card {
      .desktop &,
      .large & {
        width: 30%;
      }
    }
  }
}
</style>
